import React, { useMemo } from 'react';
import { FieldRenderProps } from 'react-final-form';
import cn from 'classnames';
import _ from 'lodash';
import { RadioButton, SelectBasic, ICONS } from 'ui-kit';
import { useIntl } from 'react-intl';
import { ETranslations } from '../../../types/translates';
import { useFormVisitTimes } from '../hooks/useFormVisitTimes';
import useChoiceVisitTimeSelectors from './hooks/useChoiceVisitTimeSelectors';
import styles from './style.module.scss';

const ChoiceVisitTimeSelectors = ({
  value,
  onChange,
  onBlur,
  disabled,
  touched,
  newDesign = false,
  isFromManagement = false,
}: any) => {
  const {
    isCreateBooking,
    getHours,
    handleHour,
    getHourOptions,
    intl,
    getMinutes,
    handleMinute,
    getMinuteOptions,
    isTablet,
  } = useChoiceVisitTimeSelectors({
    value,
    onChange,
    touched,
    onBlur,
    disabled,
    isFromManagement,
  });

  return (
    <div
      className={cn('hours-mins', {
        [styles.hoursMins]: newDesign && isCreateBooking && !isFromManagement,
        [styles.hoursMinsEdit]:
          (newDesign && !isCreateBooking) || isFromManagement,
      })}
    >
      <SelectBasic
        value={getHours()}
        menuPlacement={isTablet ? 'top' : 'bottom'}
        onChange={handleHour}
        options={getHourOptions()}
        placeholder={intl.formatMessage({ id: ETranslations.PLURAL_HOURS_NOM })}
        changedMaxSize
        isDisabled={disabled}
      />
      <SelectBasic
        value={getMinutes()}
        menuPlacement={isTablet ? 'top' : 'bottom'}
        changedMaxSize
        onChange={handleMinute}
        options={getMinuteOptions()}
        placeholder={intl.formatMessage({
          id: ETranslations.PLURAL_MINUTES_NOM,
        })}
        isDisabled={disabled}
      />
    </div>
  );
};

const ChoiceVisitTimeButtons = ({
  value,
  onChange,
  disabled,
  newDesign = false,
}: any) => {
  const { options } = useFormVisitTimes();
  const intl = useIntl();
  const noLimit = useMemo(() => _.last(options), [options]);

  const defaultIsNotAvailable = useMemo(
    () => !options.includes(120),
    [options]
  );

  return (
    <RadioButton
      value={value}
      onChange={onChange}
      disabled={disabled || defaultIsNotAvailable}
      className={styles.radioButtons}
    >
      <RadioButton.Button className={styles.infinity} value={noLimit}>
        {newDesign ? (
          <ICONS.InfinityLogo fill="var(--gl_text_constant_primary2)" />
        ) : (
          intl.formatMessage({ id: ETranslations.NO_LIMIT })
        )}
      </RadioButton.Button>
    </RadioButton>
  );
};

export const ChoiceVisitTimeButtonsInput: React.FC<
  FieldRenderProps<string, any>
> = ({ input, meta, ...rest }) => (
  <ChoiceVisitTimeButtons {...input} {...meta} {...rest} />
);

export const ChoiceVisitTimeControls: React.FC<FieldRenderProps<any>> = ({
  input,
  meta,
  ...rest
}) => <ChoiceVisitTimeSelectors {...input} {...meta} {...rest} />;
